import {StructureColumn} from "./structureColumn";


export class StructureMosaic {
    defaultOptions = {
        wrapperClass: 'structure__content',
        slideClass: 'mosaic',
        spaceBetween: 1,
        slidesPerView: 1,
        slidesPerGroup: 1,
        initialSlide: 0,
        navigation: {
            prevEl: '.pagination-control__navigation--prev',
            nextEl: '.pagination-control__navigation--next'
        },
        slideClassHidden: '[class^="mosaic__unit--"]',
    };

    slidesPerView = 3;

    structureClass = '.structure--mosaic';

    constructor() {
        this.init();
    }

    init() {
        new StructureColumn(this.defaultOptions, this.slidesPerView, this.structureClass);
    }
}
